import { useSpirals } from './useSpirals'

export const useSpiralById = ({ spiralId }: { spiralId: string }) => {
  const { spirals } = useSpirals()
  const spiral = spirals.find((spiral) => spiral.id === spiralId)

  return { spiral }
}
